{
  "title": "الدعم",
  "description": "تذاكرك مع فريق دعم bPanel، وروابط للوثائق وحالة الخدمة.",
  "new": {
    "title": "تذكرة جديدة",
    "description": "اشرح المشكلة واختر السيرفر، ونرد عليك هنا.",
    "button": "تذكرة جديدة",
    "created": "تم فتح التذكرة {{number}}",
    "submit": "إرسال التذكرة",
    "steps": {
      "details": "تفاصيل المشكلة",
      "diagnostics": "التشخيص والإرسال"
    },
    "fields": {
      "category": "نوع الطلب",
      "server": "السيرفر",
      "priority": "الأولوية",
      "subject": "العنوان",
      "body": "الوصف"
    },
    "noServer": "بدون سيرفر محدد",
    "subjectPlaceholder": "مثلًا: النسخ الاحتياطي يفشل على server2",
    "bodyHint": "اكتب ما توقعته وما حدث فعلًا ومتى بدأت المشكلة. التفاصيل تختصر وقت الحل.",
    "review": "مراجعة التذكرة"
  },
  "ticket": {
    "title": "تذكرة",
    "description": "المحادثة مع فريق الدعم.",
    "reopen": "إعادة فتح التذكرة",
    "close": "إغلاق التذكرة",
    "awaitingUs": "التذكرة بانتظار ردنا. موعد أول رد لهذه الأولوية: {{target}}",
    "details": "تفاصيل التذكرة",
    "number": "رقم التذكرة",
    "openedBy": "فتحها",
    "opened": "تاريخ الفتح",
    "assignee": "يتابعها",
    "unassigned": "بانتظار التعيين",
    "resolved": "تاريخ الحل",
    "closeTitle": "إغلاق التذكرة؟",
    "closeDescription": "ستُعدّ المشكلة محلولة. يمكنك إعادة فتحها أو الرد عليها خلال 14 يومًا.",
    "replyReopen": "رد لإعادة فتح التذكرة",
    "reply": "ردك",
    "message": "الرسالة",
    "messageRequired": "اكتب ردك أولًا",
    "placeholder": "اكتب ردك لفريق الدعم",
    "send": "إرسال الرد",
    "back": "كل التذاكر"
  },
  "list": {
    "caption": "تذاكر الدعم",
    "search": "ابحث بالعنوان أو الرقم",
    "columns": {
      "subject": "العنوان",
      "server": "السيرفر",
      "category": "النوع",
      "priority": "الأولوية",
      "status": "الحالة",
      "updated": "آخر تحديث"
    },
    "noServer": "بدون سيرفر",
    "empty": {
      "title": "لا توجد تذاكر بعد",
      "body": "إذا احتجت مساعدة في سيرفر أو فاتورة أو نقل من cPanel، افتح تذكرة ونرد عليك هنا."
    },
    "waitingOnYou_zero": "لا توجد تذاكر بانتظارك.",
    "waitingOnYou_one": "تذكرة واحدة بانتظار ردك.",
    "waitingOnYou_two": "تذكرتان بانتظار ردك.",
    "waitingOnYou_few": "{{count}} تذاكر بانتظار ردك.",
    "waitingOnYou_many": "{{count}} تذكرة بانتظار ردك.",
    "waitingOnYou_other": "{{count}} تذكرة بانتظار ردك."
  },
  "status": {
    "open": "مفتوحة",
    "waiting_on_customer": "بانتظارك",
    "waiting_on_support": "بانتظار الدعم",
    "resolved": "محلولة"
  },
  "priority": {
    "low": {
      "label": "منخفضة",
      "when": "سؤال عام أو طلب لا يؤثر على المواقع.",
      "target": "أول رد خلال يومي عمل"
    },
    "normal": {
      "label": "عادية",
      "when": "شيء لا يعمل كما يجب، لكن المواقع تعمل.",
      "target": "أول رد خلال يوم عمل"
    },
    "high": {
      "label": "عالية",
      "when": "ميزة متعطلة لعدة حسابات، أو السيرفر بطيء بشكل واضح.",
      "target": "أول رد خلال 8 ساعات"
    },
    "urgent": {
      "label": "عاجلة",
      "when": "المواقع أو البريد متوقف على أحد السيرفرات.",
      "target": "أول رد خلال ساعتين، كل أيام الأسبوع"
    },
    "note": "أيام العمل من الأحد إلى الخميس بتوقيت الرياض. نلتزم بهذه الأوقات، وقد نعدّل الأولوية بعد قراءة التذكرة مع توضيح السبب."
  },
  "category": {
    "technical": {
      "label": "مشكلة تقنية",
      "hint": "السيرفر أو اللوحة أو المواقع أو البريد"
    },
    "billing": {
      "label": "الفوترة",
      "hint": "الفواتير والدفعات والضريبة",
      "tip": "لا نحتاج إلى بيانات من السيرفر في أسئلة الفواتير والدفعات. اذكر رقم الفاتورة إن وُجد."
    },
    "migration": {
      "label": "النقل من cPanel",
      "hint": "نقل الحسابات والمواقع والبريد",
      "tip": "اذكر عدد الحسابات وحجمها التقريبي والموعد المناسب لك، ونجهز لك خطة النقل."
    },
    "licensing": {
      "label": "الترخيص والتفعيل",
      "hint": "مفتاح التفعيل وحالة الاشتراك والتثبيت"
    },
    "other": {
      "label": "أخرى",
      "hint": "أي شيء آخر"
    }
  },
  "help": {
    "title": "مصادر أخرى",
    "docs": {
      "title": "الوثائق",
      "body": "شروحات التثبيت والنقل من cPanel والنسخ الاحتياطي. قيد الإعداد حاليًا."
    },
    "status": {
      "title": "حالة الخدمة",
      "body": "حالة خدمة التراخيص والتحديثات والذكاء الاصطناعي. الصفحة قيد الإعداد."
    }
  },
  "attachments": {
    "label": "المرفقات",
    "add": "إرفاق ملف",
    "hint": "حتى 5 ملفات، 10 MB لكل ملف: صور وPDF وملفات نصية وZIP.",
    "remove": "إزالة {{name}}",
    "tooMany": "الحد الأقصى 5 ملفات.",
    "tooLarge": "الملف {{name}} أكبر من 10 MB.",
    "none": "بدون مرفقات",
    "demo": "الملفات في النسخة التجريبية للعرض فقط",
    "count_zero": "بدون ملفات",
    "count_one": "ملف واحد",
    "count_two": "ملفان",
    "count_few": "{{count}} ملفات",
    "count_many": "{{count}} ملفًا",
    "count_other": "{{count}} ملف"
  },
  "diagnostics": {
    "title": "بيانات التشخيص",
    "intro": "بيانات تقنية من السيرفر تساعد الدعم على فهم المشكلة بسرعة. المشاركة اختيارية، وهذه هي البيانات التي تصلنا بالضبط.",
    "noServer": "لم تختر سيرفرًا، لذلك لا توجد بيانات تشخيص للمشاركة. يمكنك الرجوع واختيار سيرفر.",
    "notAllowed": "دورك {{role}}، والمشاركة متاحة للمالك والمدير والتقني فقط.",
    "notInstalled": "لم يتصل السيرفر {{host}} بعد، لذلك لا توجد بيانات تشخيص.",
    "share": "مشاركة بيانات التشخيص من {{host}}",
    "shareHint": "نلتقط البيانات الآن ونرفقها بالتذكرة، ولا تتحدّث تلقائيًا بعد ذلك.",
    "previewOn": "هذه هي البيانات التي نشاركها",
    "previewOff": "هذه هي البيانات التي نشاركها إذا فعّلت المشاركة",
    "collected": "من {{host}}، {{when}}",
    "versions": "الإصدارات",
    "channel": "قناة التحديث",
    "os": "نظام التشغيل",
    "kernel": "النواة",
    "subscription": "الاشتراك",
    "plan": "الباقة",
    "lastCheckIn": "آخر اتصال",
    "never": "لم يتصل بعد",
    "graceUntil": "المهلة حتى",
    "jobTypes": {
      "backup": "النسخ الاحتياطي",
      "ssl_renewal": "تجديد شهادة SSL",
      "update": "تحديث bPanel",
      "migration": "النقل من cPanel",
      "mail_queue": "طابور البريد",
      "dns_sync": "مزامنة DNS"
    },
    "noFailures": "لا توجد مهام فاشلة في آخر 7 أيام.",
    "services": "الخدمات",
    "serviceState": {
      "running": "تعمل",
      "stopped": "متوقفة",
      "degraded": "تواجه مشكلة"
    },
    "neverTitle": "لا نشاركه أبدًا",
    "excluded": {
      "domains": "أسماء المجالات والمواقع",
      "emails": "عناوين البريد ومحتوى الرسائل",
      "accounts": "أسماء حسابات الاستضافة وبيانات عملائك",
      "files": "الملفات ومحتوى المواقع",
      "databases": "قواعد البيانات ومحتواها",
      "logs": "سجلات الوصول وسجلات المواقع",
      "visitors": "عناوين IP للزوار",
      "secrets": "كلمات المرور والمفاتيح"
    },
    "showRaw": "عرض البيانات كما تُرسل",
    "hideRaw": "إخفاء البيانات",
    "sharedOn": "مشاركة من {{host}}، {{when}}",
    "view": "عرض بيانات التشخيص",
    "notShared": "لم تُشارك بيانات تشخيص مع هذه التذكرة.",
    "drawerDescription": "البيانات التي وصلت إلى الدعم مع التذكرة.",
    "failures_zero": "المهام الفاشلة في آخر 7 أيام",
    "failures_one": "المهام الفاشلة في آخر 7 أيام (1)",
    "failures_two": "المهام الفاشلة في آخر 7 أيام (2)",
    "failures_few": "المهام الفاشلة في آخر 7 أيام ({{count}})",
    "failures_many": "المهام الفاشلة في آخر 7 أيام ({{count}})",
    "failures_other": "المهام الفاشلة في آخر 7 أيام ({{count}})",
    "attempts_zero": "بدون محاولات",
    "attempts_one": "محاولة واحدة",
    "attempts_two": "محاولتان",
    "attempts_few": "{{count}} محاولات",
    "attempts_many": "{{count}} محاولة",
    "attempts_other": "{{count}} محاولة"
  },
  "thread": {
    "label": "المحادثة",
    "staff": "دعم bPanel، {{team}}",
    "events": {
      "status": "تغيّرت الحالة إلى: {{status}}",
      "priority": "تغيّرت الأولوية إلى: {{priority}}",
      "diagnostics": "تمت مشاركة بيانات التشخيص من {{host}}",
      "rated": "قيّمت الدعم {{score}} من 5"
    }
  },
  "staffTeams": {
    "support": "الدعم التقني",
    "migration": "فريق النقل",
    "billing": "الفوترة"
  },
  "rating": {
    "title": "كيف كانت تجربتك مع الدعم؟",
    "description": "يصل تقييمك إلى فريق الدعم.",
    "thanks": "شكرًا على تقييمك",
    "yourScore": "تقييمك {{score}} من 5",
    "labels": {
      "1": "سيئة جدًا",
      "2": "سيئة",
      "3": "مقبولة",
      "4": "جيدة",
      "5": "ممتازة"
    },
    "comment": "تعليق",
    "submit": "إرسال التقييم"
  },
  "toasts": {
    "closed": "تم إغلاق التذكرة",
    "reopened": "تمت إعادة فتح التذكرة",
    "rated": "وصلنا تقييمك، شكرًا لك"
  }
}
